// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { FC, Children } from 'react';

export interface ColorPassType {
  splitText: string;
  color?: string;
}

const ColorPass: FC<ColorPassType> = ({ children, splitText, color = 'black' }) => {
  const text = children.toString();
  const myRe = new RegExp(splitText.replaceAll('[', '\\['), 'gi');
  let arrayIncludeValues = [];
  while (myRe.exec(text) !== null && splitText) {
    arrayIncludeValues = [...arrayIncludeValues, text.slice(myRe.lastIndex - splitText.length, myRe.lastIndex)];
  }

  return (
    <span>
      {Children.toArray(
        text.split(myRe).map((val, i) => (
          <>
            <span>{val}</span>
            <span style={{ color, fontWeight: 600 }}>{arrayIncludeValues[i]}</span>
          </>
        )),
      )}
    </span>
  );
};

export default ColorPass;
